import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-successful',
  templateUrl: './reset-password-successful.component.html',
  styleUrls: ['./reset-password-successful.component.scss']
})
export class ResetPasswordSuccessfulComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
